// P2 subject catalog remediation.
//
// `/api/subjects` (server/router/api/subjects.ts -> upchieve.subjects JOIN
// upchieve.topics) is the ONLY catalog `/session/new` accepts today --
// `sessionType`/`sessionSubTopic` are resolved against exactly these two
// tables (server/services/SessionService.ts). Borna's separate education
// catalog (`education_courses`/`education_course_scopes`) has no route, no
// seed data, and no FK into `subjects`/`topics` (see
// database/migrations/20260905130000_create_education_course_catalog_foundation.sql),
// so it cannot back this screen without a backend change P2 is not
// authorized to make.
//
// Of the six legacy topics the live DB currently returns, only three have
// subtopics whose actual subject matter is universal, real content a Borna
// teacher can truthfully help with. The other three are inherently and
// specifically American (US college admissions process, the SAT/ACT exams,
// U.S. History) and have no honest Persian relabeling -- they are excluded
// entirely, not renamed.
//
// SUPPORTED_TOPICS is an allowlist by the backend's own `topic.name` slug --
// the value actually sent as `sessionType`. TOPIC_LABELS/SUBTOPIC_LABELS
// supply DISPLAY TEXT ONLY; every key here is a real, currently-active
// backend slug (verified against the live local DB), and `selectTopic()` in
// index.vue still sends the unmodified slug as `sessionSubTopic`.
export const SUPPORTED_TOPICS = ['math', 'science', 'readingWriting']

export const TOPIC_LABELS = {
  math: { fa: 'ریاضی', en: 'Mathematics' },
  science: { fa: 'علوم', en: 'Science' },
  readingWriting: { fa: 'زبان انگلیسی', en: 'English' },
}

export const SUBTOPIC_LABELS = {
  // math
  prealgebra: { fa: 'پیش‌جبر', en: 'Prealgebra' },
  algebraOne: { fa: 'جبر ۱', en: 'Algebra 1' },
  algebraTwo: { fa: 'جبر ۲', en: 'Algebra 2' },
  geometry: { fa: 'هندسه', en: 'Geometry' },
  trigonometry: { fa: 'مثلثات', en: 'Trigonometry' },
  precalculus: { fa: 'پیش‌دانشگاهی', en: 'Precalculus' },
  calculusAB: { fa: 'حسابان', en: 'Calculus AB' },
  calculusBC: { fa: 'حسابان پیشرفته', en: 'Calculus BC' },
  integratedMathOne: { fa: 'ریاضی ترکیبی ۱', en: 'Integrated Math One' },
  integratedMathTwo: { fa: 'ریاضی ترکیبی ۲', en: 'Integrated Math Two' },
  integratedMathThree: { fa: 'ریاضی ترکیبی ۳', en: 'Integrated Math Three' },
  integratedMathFour: { fa: 'ریاضی ترکیبی ۴', en: 'Integrated Math Four' },
  statistics: { fa: 'آمار', en: 'Statistics' },
  // science
  biology: { fa: 'زیست‌شناسی', en: 'Biology' },
  chemistry: { fa: 'شیمی', en: 'Chemistry' },
  physicsOne: { fa: 'فیزیک ۱', en: 'Physics 1' },
  physicsTwo: { fa: 'فیزیک ۲', en: 'Physics 2' },
  environmentalScience: { fa: 'علوم محیط‌زیست', en: 'Environmental Science' },
  // readingWriting (English language reading/writing skills)
  reading: { fa: 'خواندن و درک مطلب', en: 'Reading' },
  humanitiesEssays: { fa: 'مقاله‌نویسی', en: 'Humanities Essays' },
  essayPlanning: { fa: 'برنامه‌ریزی مقاله', en: 'Essay Planning' },
  essayFeedback: { fa: 'بازخورد مقاله', en: 'Essay Feedback' },
}

export function localizedTopicLabel(topicSlug, fallback, locale) {
  const entry = TOPIC_LABELS[topicSlug]
  if (!entry) return fallback
  return locale === 'en' ? entry.en : entry.fa
}

export function localizedSubtopicDisplayNames(
  subtopics,
  fallbackNames,
  locale
) {
  const result = {}
  for (const subtopic of subtopics) {
    const entry = SUBTOPIC_LABELS[subtopic]
    result[subtopic] = entry
      ? locale === 'en'
        ? entry.en
        : entry.fa
      : fallbackNames[subtopic] || subtopic
  }
  return result
}
